import axios from "axios";

const URL = "https://api-blog-bsq7.onrender.com";

const api = axios.create({
  baseURL: URL,
  timeout: 12000,
});

api.interceptors.request.use(
  (config) => {
    const usuario = JSON.parse(localStorage.getItem("usuario-blog"));

    if (usuario?.token) {
      config.headers.Authorization = `Bearer ${usuario.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;